import React, { useEffect } from 'react'
import { Form, Input, Popover, Switch, Row, Col, Space, Typography, Card } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { specialFieldValidation, hexToRGBA } from '../../../../lib/utils'
import SectionWithBorder from './SectionWithBorder'

const { Text } = Typography

const ContactDetailsForm = ({
  form,
  specialFormState,
  setSpecialFormState,
  token,
  isDependant,
  dependantSameContact,
  setDependantSameContact,
  mainPatientInfo
}) => {
  // Update form fields when dependantSameContact changes
  useEffect(() => {
    if (isDependant && dependantSameContact && mainPatientInfo) {
      form.setFieldsValue({
        email: mainPatientInfo.email,
        phoneNumber: mainPatientInfo.phoneNumber?.replace('+27', '') || ''
      })
    } else if (isDependant && !dependantSameContact) {
      // Clear the contact fields when the switch is turned off
      form.setFieldsValue({
        email: '',
        phoneNumber: ''
      })
    }
  }, [dependantSameContact, isDependant, mainPatientInfo, form])

  return (
    <SectionWithBorder title='Contact Details' token={token} icon={faEnvelope}>
      <Space direction='vertical' size={24} style={{ width: '100%' }}>
        {/* Dependant Switch */}
        {mainPatientInfo && (
          <Card
            size='small'
            style={{
              borderRadius: '12px',
              border: `2px solid ${hexToRGBA(token.colorInfo, 0.15)}`,
              backgroundColor: hexToRGBA(token.colorInfo, 0.04),
              textAlign: 'center'
            }}
            bodyStyle={{ padding: '20px' }}
          >
            <Space direction='vertical' size={16}>
              <Text strong style={{ fontSize: '15px' }}>
                Contact Information Preference
              </Text>
              <Space size={16} align='center'>
                <Text>Use Main Member's Contact Details?</Text>
                <Switch
                  checked={dependantSameContact}
                  checkedChildren='Yes'
                  unCheckedChildren='No'
                  size='default'
                  onChange={(boolean) => {
                    setDependantSameContact(boolean)
                  }}
                />
              </Space>
            </Space>
          </Card>
        )}

        {/* Contact Fields */}
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              label={
                <Text strong style={{ fontSize: '15px' }}>
                  Email Address
                </Text>
              }
              name='email'
              rules={[{ type: 'email', message: 'Please enter a valid email address' }]}
            >
              <Input
                size='large'
                placeholder='e.g. jane.doe@gmail.com'
                style={{ borderRadius: '8px' }}
                disabled={isDependant && dependantSameContact}
                prefix={
                  <FontAwesomeIcon icon={faEnvelope} style={{ color: token.colorTextSecondary, marginRight: '8px' }} />
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Popover
              placement='topRight'
              content={
                <div>
                  <Text strong style={{ display: 'block', marginBottom: '8px' }}>
                    SMS Verification
                  </Text>
                  <Text type='secondary'>A one-time PIN will be sent to this number for verification</Text>
                </div>
              }
              title={
                <Space>
                  <FontAwesomeIcon icon={faPhone} style={{ color: token.colorPrimary }} />
                  <Text style={{ color: token.colorPrimary }}>Phone Verification</Text>
                </Space>
              }
              trigger='focus'
            >
              <Form.Item
                label={
                  <Text strong style={{ fontSize: '15px' }}>
                    Phone Number
                  </Text>
                }
                name='phoneNumber'
                rules={[{ required: !isDependant, message: 'Phone number is required' }]}
              >
                <Input
                  size='large'
                  maxLength={15}
                  style={{ borderRadius: '8px' }}
                  onChange={(e) => {
                    specialFieldValidation(form, specialFormState, setSpecialFormState, {
                      key: 'phoneNumber',
                      event: e,
                      validationConfig: {
                        letters: { allowed: false, onlyCaps: false },
                        numbers: true,
                        spaces: false
                      }
                    })
                  }}
                  addonBefore={<span style={{ color: token.colorPrimary, fontWeight: '500' }}>+27</span>}
                  placeholder='8288*****'
                  disabled={isDependant && dependantSameContact}
                />
              </Form.Item>
            </Popover>
          </Col>
        </Row>
      </Space>
    </SectionWithBorder>
  )
}

export default ContactDetailsForm
